var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editor",staticClass:"wEditor",class:_vm.currentTheme,staticStyle:{"color":"#fff"}})
}
var staticRenderFns = []

export { render, staticRenderFns }